import { render, staticRenderFns } from "./PlayerGroupBadge.vue?vue&type=template&id=2179152a"
import script from "./PlayerGroupBadge.js?vue&type=script&lang=js&external"
export * from "./PlayerGroupBadge.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports